import React from "react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import routes from "../../constants/routes";
import { PageHeader, PageRoot } from "../../components";
import { withRouter, RouteComponentProps } from "react-router";
import DetailGrid from "../../components/details/DetailGrid";
import { connect } from "react-redux";
import { Premises } from "../../constants/interfaces";
import { premisesActions } from "../../reducers/premises";
import { searchTableData } from "../../utils/table";
import { Card, Typography } from "@material-ui/core";
import { Classes } from "jss";

const styles = (theme: Theme) =>
  createStyles({
    noResults: {
      padding: theme.spacing(4)
    }
  });

type State = {
  filteredPremises: Premises[];
  searchTerm: string;
};

type Props = RouteComponentProps & {
  classes: Classes;
  premises: Premises[];
  getPremises: () => Promise<void>;
  loading: boolean;
};

class MyPremises extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filteredPremises: [],
      searchTerm: ""
    };
    this.formatDetails = this.formatDetails.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    this.props.getPremises();
  }

  formatDetails(premises: Premises[]) {
    return premises.map(premise => ({
      id: premise.cmAcmCaseIdentifier,
      title: premise.premisesName,
      listItems: [
        {
          icon: "account_balance",
          label: premise.parentLegalEntity.legalEntityName
        }
      ],
      onView: () =>
        this.props.history.push(
          `${routes.MY_PREMISE.url}${premise.cmAcmCaseIdentifier}`
        )
    }));
  }

  onSearch(searchTerm: string) {
    const filteredPremises = searchTableData(
      searchTerm,
      // Will return results (partially) matching premises name or descriptor
      ["premisesName", "premisesDescriptor"],
      this.props.premises
    );
    this.setState({
      searchTerm: searchTerm.trim(),
      filteredPremises
    });
  }

  render() {
    const { classes, premises } = this.props;
    const { filteredPremises, searchTerm } = this.state;
    const noResults = searchTerm && filteredPremises.length < 1;
    return (
      <PageRoot>
        <PageHeader
          breadcrumbLinks={[
            {
              label: routes.HOME.label,
              route: routes.HOME.url
            }
          ]}
          label={routes.MY_PREMISES.label}
        />
        <DetailGrid
          details={this.formatDetails(searchTerm ? filteredPremises : premises)}
          onSubmitSearch={this.onSearch}
          btnDisabled={this.props.loading}
        />
        {noResults && (
          <Card className={classes.noResults}>
            <Typography align="center" color="primary" variant="h5">
              {`Oops, no results matching "${searchTerm}"`}
            </Typography>
          </Card>
        )}
      </PageRoot>
    );
  }
}

const mapDispatchToProps = {
  getPremises: premisesActions.getPremises
};

const mapStateToProps = ({ premises }: any) => {
  return {
    premises: premises.premises,
    loading: premises.loading
  };
};

export const styled = withStyles(styles)(MyPremises);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(styled));
